import { DriveDomCacheService } from './drive-dom-cache.service';
import { Store } from '@ngxs/store';
import { StoppedDragging } from '../state/actions/events';
import { StartedDragging } from '../state/actions/events';
import * as i0 from "@angular/core";
import * as i1 from "./drive-dom-cache.service";
import * as i2 from "@ngxs/store";
var DragEntryService = /** @class */ (function () {
    function DragEntryService(domCache, store) {
        this.domCache = domCache;
        this.store = store;
    }
    DragEntryService.prototype.start = function (e) {
        this.store.dispatch(new StartedDragging());
    };
    DragEntryService.prototype.move = function (e) {
        this.domCache.dragPreview.style.top = e.center.y + 'px';
        this.domCache.dragPreview.style.left = e.center.x + 'px';
    };
    DragEntryService.prototype.end = function () {
        this.store.dispatch(new StoppedDragging());
    };
    DragEntryService.ngInjectableDef = i0.defineInjectable({ factory: function DragEntryService_Factory() { return new DragEntryService(i0.inject(i1.DriveDomCacheService), i0.inject(i2.Store)); }, token: DragEntryService, providedIn: "root" });
    return DragEntryService;
}());
export { DragEntryService };
